import React, { useRef, useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';

const ImageUpload = ({ currentImage, onFileSelect, onRemoveImage }) => {
  const fileInputRef = useRef(null);
  const [preview, setPreview] = useState(currentImage || null);
  const [dragActive, setDragActive] = useState(false);

  // Sincronizar si entra una imagen existente (al editar)
  useEffect(() => {
    setPreview(currentImage);
  }, [currentImage]);

  const processFile = (file) => {
    if (!file) return;
    const objectUrl = URL.createObjectURL(file);
    setPreview(objectUrl);
    onFileSelect(file);
  };

  const handleFileChange = (e) => {
    processFile(e.target.files[0]);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);
    processFile(e.dataTransfer.files[0]);
  };

  const handleRemove = () => {
    setPreview(null);
    onRemoveImage();

    // Limpiar el input file de HTML para quitar el nombre del archivo
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <div>
      <Form.Label className="mb-2">Imagen</Form.Label>

      {/* Input real, oculto, pero sigue existiendo en el DOM */}
      <input
        type="file"
        accept="image/jpeg, image/png, image/webp"
        onChange={handleFileChange}
        ref={fileInputRef}
        style={{ display: 'none' }}
      />

      {!preview ? (
        <div
          className={`dropzone-upload ${dragActive ? 'dropzone-active' : ''}`}
          onClick={() => fileInputRef.current?.click()}
          onDragOver={(e) => {
            e.preventDefault();
            setDragActive(true);
          }}
          onDragLeave={() => setDragActive(false)}
          onDrop={handleDrop}
        >
          <i className="fas fa-cloud-upload-alt"></i>
          <div className="dropzone-text">
            Arrastra una imagen o haz clic para seleccionar
          </div>
          <div className="dropzone-hint">
            Formatos permitidos: JPG, PNG, WEBP. Tamaño máximo: 5MB
          </div>
        </div>
      ) : (
        <div className="preview-container">
          <div className="imagen-preview-wrapper">
            <img src={preview} alt="Preview" className="imagen-preview" />
          </div>
          <div className="d-flex gap-2 mt-2">
            <button
              type="button"
              className="btn-cambiar-imagen"
              onClick={() => fileInputRef.current?.click()}
            >
              <i className="fas fa-sync-alt me-1"></i>
              Cambiar
            </button>
            <button
              type="button"
              className="btn-eliminar-imagen"
              onClick={handleRemove}
            >
              <i className="fas fa-trash me-1"></i>
              Eliminar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageUpload;